var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "previewable-image" },
    [
      _vm.src
        ? [
            _c("div", { staticClass: "previewable-image__actions" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-sm",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.showPreview = true
                    },
                  },
                },
                [
                  _c("i", { staticClass: "bi bi-arrows-fullscreen mr-1" }),
                  _vm._v(" Preview\n      "),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary btn-sm",
                  attrs: { type: "button" },
                  on: { click: _vm.openOriginal },
                },
                [
                  _c("i", { staticClass: "bi bi-box-arrow-up-right mr-1" }),
                  _vm._v(" Open original\n      "),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "previewable-image__image-wrap" }, [
              _c("img", {
                staticClass: "previewable-image__img img-fluid",
                attrs: { src: _vm.src, alt: _vm.alt },
                on: {
                  click: function ($event) {
                    _vm.showPreview = true
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _vm.showPreview
              ? _c(
                  "div",
                  {
                    staticClass: "previewable-image__modal",
                    style: {
                      top: `${_vm.topOffset}px`,
                      "--top-offset": `${_vm.topOffset}px`,
                    },
                    on: {
                      click: function ($event) {
                        _vm.showPreview = false
                      },
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "previewable-image__modal-close",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            _vm.showPreview = false
                          },
                        },
                      },
                      [_vm._v("\n        ×\n      ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "previewable-image__modal-content",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "previewable-image__modal-img",
                          attrs: { src: _vm.src, alt: _vm.alt },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }